var module = angular.module('components');
module.component('caVariantDetailSearchSingleSelect', {
    templateUrl: 'components/genericcomponents/variantdetailsearchsingleselect.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        model: '=',
        pageSize: '<',
        disabledBy: '<',
        onSelected: '&',
        onRemoved: '&'
    },
    controller: ['$q', '$scope', '$timeout', 'ProductsApiService', 'loadSpinnerService', 'ToasterService', controller]
});

function controller($q, $scope, $timeout, ProductsApiService, loadSpinnerService, ToasterService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    vm.searchResultVariantDetail = [];
    vm.currentPage = 1;

    vm.refresh = refresh;
    vm.select = select;
    vm.remove = remove;

    function onInit() {
        if (!vm.pageSize) {
            vm.pageSize = 20;
        }
    }

    function onChanges(changes) {
        if (changes.disabledBy &&
            changes.disabledBy.currentValue !== changes.disabledBy.previousValue &&
            changes.disabledBy.currentValue === true) {
            vm.model = undefined;
        }
    }

    function onDestroy() {
    }

    // Refreshes the contents of the drop-down-list of selectable articles.
    function refresh(filter) {
        var request = {
            currentPage: vm.currentPage,
            filter: filter,
            pageSize: vm.pageSize,
            variantDetailType: 1
        };
        ProductsApiService.getVariantDetailOptionsPaged(request).then(function(response) {
            vm.searchResultVariantDetail = [];

            _.forEach(response.data.results, function(obj){
                vm.searchResultVariantDetail.push(obj);
            });

        }, function(error) {
            ToasterService.showError(error.errors);
        });
    }

    function select() {
        vm.onSelected();
    }

    function remove() {
        vm.model = undefined;
        $timeout(function() { vm.onRemoved();}, 100);
    }
}
